
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M9.394 16.333a17.51 17.51 0 011.39 2.093c.354.686.5 1.15.763 1.973.154.454.3.592.608.592.336 0 .49-.231.608-.592.246-.778.435-1.37.736-1.936.59-1.084 1.335-2.048 2.062-2.974.2-.26 1.471-1.789 2.043-3.002 0 0 .7-1.325.7-3.178 0-1.733-.69-2.936-.69-2.936l-1.997.547-1.217 3.26-.3.445-.064.084-.082.102-.136.167-.2.204-1.08.899-2.698 1.593-.446 2.659z","fill":"#34A853"}}),_c('path',{attrs:{"d":"M6.606 12.265c.663 1.538 1.926 2.882 2.788 4.068l4.569-5.522s-.645.862-1.808.862c-1.3 0-2.352-1.055-2.352-2.39 0-.918.536-1.547.536-1.547l-3.097.843-.636 3.686z","fill":"#FBBC04"}}),_c('path',{attrs:{"d":"M14.017 3.289a6.13 6.13 0 013.597 3.094l-3.651 4.437s.536-.64.536-1.546c0-1.362-1.127-2.391-2.344-2.391-1.154 0-1.816.852-1.816.852V4.938l3.678-1.65z","fill":"#4285F4"}}),_c('path',{attrs:{"d":"M7.441 5.244c.909-1.102 2.498-2.241 4.695-2.241 1.062 0 1.871.287 1.871.287L10.34 7.737h-2.6l-.299-2.493z","fill":"#1A73E8"}}),_c('path',{attrs:{"d":"M6.606 12.265s-.599-1.213-.599-2.964c0-1.657.635-3.103 1.444-4.048l2.898 2.492-3.743 4.52z","fill":"#EA4335"}})])])
          )
        }
      }
    